module.exports = __webpack_public_path__ + "static/media/main_hero.e69784fa.png";